// @flow
import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import GpsFixedIcon from '@material-ui/icons/GpsFixed';
import PersonIcon from '@material-ui/icons/Person';
import makeStyles from "@material-ui/core/styles/makeStyles";
import type {TargetType, Target} from '../../types';
import SatelliteIcon from "../ui/SatelliteIcon";
import Status from '../ui/Status';
import Time from '../ui/Time';
import TargetFeederContainer from './containers/TargetFeederContainer';
import Session from './Session';

const useStyles = makeStyles(theme => ({
    tableCell: {
        paddingTop: theme.spacing(1),
        paddingLeft: 0,
        paddingRight: 0,
        paddingBottom: theme.spacing(1)
    },
    tableCellGap: {
        paddingLeft: '2ch'
    },
    maxWidthCell: {
        width: '100%'
    },
    minWidthCell: {
        width: 1,
        whiteSpace: 'nowrap',
        textAlign: 'left'
    },
    satelliteIcon: {
        float: 'right',
        marginRight: 3,
        color: theme.palette.text.secondary
    },
    personIcon: {
        marginLeft: 3,
        color: theme.palette.text.secondary
    },
    iconButton: {
        padding: 0,
        marginLeft: '.5ch'
    },
    callsign: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'center'
    }
}));

export type Props = $ReadOnly<{
    type: TargetType,
    icao: string,
    callsign: string,
    target?: Target,
    dataSource?: 'system' | 'device',
    showSession?: boolean,
    sessionStart?: number,
    hasOperator?: boolean,
    strict?: boolean,

    onLocateClick: (target: Target) => void
}>;

function TargetListItem({type, icao, callsign, dataSource, showSession, sessionStart, hasOperator, onLocateClick}: Props) {
    const classes = useStyles();

    return (
        <TableRow>
            <TableCell scope="row" classes={{ root: classes.tableCell }} className={classes.maxWidthCell}>
                <span className={classes.callsign}>
                    {callsign}
                    {(dataSource && dataSource === 'device') &&
                        <SatelliteIcon fontSize="small" className={classes.satelliteIcon}/>
                    }
                </span>
            </TableCell>
            <TableCell align="right" classes={{ root: classes.tableCell }} className={classes.minWidthCell}>
                <TargetFeederContainer type={type} icao={icao}>
                    {(target) => (
                        <React.Fragment>
                            <Status dateString={target && target.TimeOfTrackInformation} />
                            <Time dateString={target && target.TimeOfTrackInformation} />
                        </React.Fragment>
                    )}
                </TargetFeederContainer>
            </TableCell>
            <TableCell align="right" classes={{ root: classes.tableCell }} className={classes.minWidthCell}>
                <TargetFeederContainer type={type} icao={icao}>
                    {(target) => {
                        if(!target) {
                            return null;
                        }

                        const handleLocateClick = () => target && onLocateClick(target);

                        return (
                            <IconButton size="small" onClick={handleLocateClick} className={classes.iconButton}>
                                <GpsFixedIcon fontSize="small" />
                            </IconButton>
                        );
                    }}
                </TargetFeederContainer>
            </TableCell>
            {showSession &&
                <React.Fragment>
                    <TableCell align="right" classes={{ root: classes.tableCell }} className={classes.tableCellGap}>
                        <TargetFeederContainer type={type} icao={icao}>
                            {(target) => (
                                <Session sessionStart={sessionStart} lastUpdate={target && target.TimeOfTrackInformation}/>
                            )}
                        </TargetFeederContainer>
                    </TableCell>
                    <TableCell classes={{ root: classes.tableCell }}>
                        {hasOperator && <PersonIcon fontSize="small" className={classes.personIcon}/>}
                    </TableCell>
                </React.Fragment>
            }
        </TableRow>
    );
}

export default TargetListItem;